"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
exports.__esModule = true;
exports.selectCommentCount = exports.selectIsDirty = exports.selectEnabled = exports.selectCommentFactory = exports.selectCommentsForContentPathFactory = exports.selectRemoteCommentCount = exports.selectFocused = exports.selectComments = void 0;
var reselect_1 = require("reselect");
var selectComments = function (state) { return state.comments.comments; };
exports.selectComments = selectComments;
var selectFocused = function (state) { return state.comments.focusedComment; };
exports.selectFocused = selectFocused;
var selectRemoteCommentCount = function (state) { return state.comments.remoteCommentCount; };
exports.selectRemoteCommentCount = selectRemoteCommentCount;
function selectCommentsForContentPathFactory(contentpath) {
    return reselect_1.createSelector(exports.selectComments, function (comments) {
        return __spreadArray([], __read(comments.values())).filter(function (comment) {
            return comment.contentpath === contentpath && !(comment.deleted || comment.resolved);
        });
    });
}
exports.selectCommentsForContentPathFactory = selectCommentsForContentPathFactory;
function selectCommentFactory(localId) {
    return reselect_1.createSelector(exports.selectComments, function (comments) {
        var comment = comments.get(localId);
        if (comment !== undefined && (comment.deleted || comment.resolved)) {
            return undefined;
        }
        return comment;
    });
}
exports.selectCommentFactory = selectCommentFactory;
var selectEnabled = function (state) { return state.settings.commentsEnabled; };
exports.selectEnabled = selectEnabled;
exports.selectIsDirty = reselect_1.createSelector(exports.selectComments, exports.selectRemoteCommentCount, function (comments, remoteCommentCount) {
    if (remoteCommentCount !== comments.size) {
        return true;
    }
    return Array.from(comments.values()).some(function (comment) {
        if (comment.deleted ||
            comment.resolved ||
            comment.replies.size !== comment.remoteReplyCount ||
            comment.originalText !== comment.text) {
            return true;
        }
        return Array.from(comment.replies.values()).some(function (reply) { return reply.deleted || reply.originalText !== reply.text; });
    });
});
var selectCommentCount = function (state) { return (__spreadArray([], __read(state.comments.comments.values())).filter(function (comment) { return !comment.deleted && !comment.resolved; }).length); };
exports.selectCommentCount = selectCommentCount;
